export const CONFIG = {
  stage: 'dev',
  baseApiUrl: 'https://api.dev.intenant.io',
  mobileApiKey: '0qYq6ONe628V5uj3mUh6P1HPDz2oB4Co5vQ9Ckre'
}

export const AWS_CONFIG = {
  Auth: {
    region: 'us-west-2',
    userPoolId: 'us-west-2_ceUgqdJiG',
    userPoolWebClientId: '2itcos672s4ctnjqn15g8pm0rq'
  }
}
